import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ACADEMY } from "@/constants/testIds";

// Fix U (2026-10-13): confirmar una accion que pide motivo (anular un pago, cancelar una inscripcion).
export default function ReasonDialog({ open, onOpenChange, title, description, confirmLabel, onConfirm }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { if (open) { setReason(""); setError(""); } }, [open]);

  const go = async () => {
    if (reason.trim().length < 2) {
      setError("Escribí el motivo");
      return;
    }
    setSaving(true);
    try {
      await onConfirm(reason.trim());
      onOpenChange(false);
    } catch (err) {
      setError(err?.message || "No se pudo completar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={ACADEMY.reasonDialog}>
        <DialogHeader>
          <DialogTitle className="font-serif text-xl">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo" data-testid={ACADEMY.reasonInput} />
        {error && <p className="text-sm text-destructive">{error}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Volver</Button>
          <Button variant="destructive" onClick={go} disabled={saving} data-testid={ACADEMY.reasonConfirmButton}>{saving ? "..." : confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
